import { isArray } from "rxjs/internal/util/isArray";
import { Injectable } from "@angular/core";

@Injectable()
export class ApiBasic {
  //s3 prod
  // public base_url = "http://127.0.0.1:8000"
  // public base_url = "http://10.0.0.3:80";

  //Desarrollo aws
  public base_url = "https://manteapi.kof.energetikamx.com";
  public base_image_url = "'https://storagelaplataformafemsatest.s3.amazonaws.com/'";
  public base_cargas_masivas = "https://manteapi.kof.energetikamx.com";

  // public base_url = "http://d431-189-203-206-59.ngrok.io"
  // public base_image_url = "https://storagelaplataformafemsadev.s3.amazonaws.com/";
  // public base_cargas_masivas = "http://d431-189-203-206-59.ngrok.io"

  //Produccion femsa
  // public base_url = "https://femsaapi.energetikatechnology.com";
  // public base_image_url = "https://storagelaplataformafemsa.s3.amazonaws.com/";
  // public base_cargas_masivas = "https://microservicio.femsa.energetikatechnology.com"

  //Azure
  // public base_url = "https://manteapi.kof.com.mx:8080";
  // public base_image_url = "https://storagelaplataformafemsaazure.s3.amazonaws.com/";
  // public base_cargas_masivas = "https://manteapi.kof.com.mx:8080"

  //Azure local
  // public base_url = "http://127.0.0.1:8000";
  // public base_image_url = "https://storagelaplataformafemsaazure.s3.amazonaws.com/";
  // public base_cargas_masivas = "http://127.0.0.1:8000";

  public timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  public stringfyObject(data) {
    var queryObject = "";
    for (let key in data) {
      queryObject += key + "=" + data[key] + "&";
    }
    return queryObject.substr(0, queryObject.length - 1);
  }

  public stringfyFilter(filter) {
    var queryFilters = "{";
    if (filter != null) {
      for (let key in filter) {
        if (
          key == "status" ||
          key == "month_list" ||
          key == "states_list" ||
          key == "region_list" ||
          key == "locations_list" ||
          key == "type_site"
        ) {
          queryFilters += '"' + key + '":[' + filter[key] + "],";
        } else {
          if (typeof filter[key] === "string") {
            queryFilters += '"' + key + '":"' + filter[key] + '",';
          } else {
            queryFilters += '"' + key + '":' + filter[key] + ",";
          }
        }
      }
      queryFilters = queryFilters.substr(0, queryFilters.length - 1);
    }
    queryFilters += "}";
    return queryFilters;
  }

  public stringfyFilter2(filter) {
    var queryFilters = "{";
    if (filter != null) {
      for (let key in filter) {
        if (filter[key] != undefined && filter[key].length != 0) {
          if (key["mes_ejecutado"] == "TODOS") {
          } else if (
            key == "status" ||
            key == "month_list" ||
            key == "states_list" ||
            key == "region_list" ||
            key == "locations_list" ||
            key == "type_site" ||
            key == "clusterName" ||
            key == "mes_ejecutado" ||
            key == "locationName" ||
            key == "regionName"
          ) {
            queryFilters += `"${key}":${JSON.stringify(filter[key])}  ,`;
          } else {
            if (typeof filter[key] === "string") {
              if (key == "anio") {
                queryFilters +=
                  '"' + "anio_creado" + '":"' + filter[key] + '",';
              } else {
                queryFilters += '"' + key + '":"' + filter[key] + '",';
              }
            } else {
              queryFilters += '"' + key + '":' + filter[key] + ",";
            }
          }
        }
        // queryFilters = queryFilters.substr(0, queryFilters.length - 1);
      }
    }
    queryFilters = queryFilters.substring(0, queryFilters.lastIndexOf(","));
    queryFilters += "}";
    return queryFilters;
  }
}
